<template>
    <base-dialog :value="dialog" :width="460" :title="$t('calendar_library.apply_program_title')" :loading="loading"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="apd">
            <div class="apd-name">{{ program ? program.name : '' }}</div>
            <div class="apd-from">{{ fromLabel }}</div>
            <div class="apd-field">
                <label class="apd-label">{{ $t('programs.days_to_assign') }}</label>
                <weekday-picker v-model="weekdays" />
            </div>
            <div class="apd-summary">{{ summary }}</div>
            <div class="apd-warn">
                <v-icon size="16" color="#D97706">mdi-alert-outline</v-icon>
                <span>{{ $t('programs.alert_replace_routines') }}</span>
            </div>
        </div>
        <template v-slot:footer>
            <dialog-actions :confirm-label="$t('common.apply')" :disabled="!dates.length" :loading="loading"
                @cancel="hide" @confirm="apply" />
        </template>
    </base-dialog>
</template>

<script>
import BaseDialog from '@/components/common/BaseDialog'
import DialogActions from '@/components/common/DialogActions'
import WeekdayPicker from '@/components/common/WeekdayPicker'
import { defaultProgramWeekdays, programSessionDates } from '@/utils/Exercises'

export default {
    name: 'ApplyProgramDialog',
    components: { BaseDialog, DialogActions, WeekdayPicker },
    props: {
        visibleDates: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            program: null,
            date: null,
            weekdays: [],
        }
    },
    computed: {
        sessions(vm = this) {
            return vm.program?.assignedRoutines?.length || 0
        },
        dates(vm = this) {
            return programSessionDates(vm.date, vm.weekdays, vm.sessions)
        },
        fromLabel(vm = this) {
            if (!vm.date) return ''
            return vm.$t('calendar_library.apply_program_from', { date: vm.$moment(vm.date).format('dddd D MMM') })
        },
        summary(vm = this) {
            const visible = new Set(vm.visibleDates)
            const inView = vm.dates.filter(date => visible.has(date)).length
            return vm.$t('calendar_library.sessions_summary', {
                total: vm.dates.length,
                inView,
                later: vm.dates.length - inView,
            })
        },
    },
    methods: {
        show(program, date) {
            const vm = this
            vm.program = program
            vm.date = date
            vm.weekdays = defaultProgramWeekdays(date, program?.daysPerWeek)
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.program = null
            vm.date = null
            vm.weekdays = []
        },
        apply() {
            const vm = this
            if (!vm.dates.length) return
            vm.$emit('apply', { program: vm.program, dates: vm.dates })
        },
    },
}
</script>

<style scoped>
.apd {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.apd-name {
    font-size: 15px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}

.apd-from {
    margin-top: -10px;
    font-size: 12px;
    color: var(--v-txtMuted-base);
    text-transform: capitalize;
}

.apd-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.apd-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: var(--v-txtMuted-base);
}

.apd-summary {
    font-size: 13px;
    color: var(--v-txtSecondary-base);
}

.apd-warn {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    background: rgba(217, 119, 6, .08);
    border: 1px solid rgba(217, 119, 6, .35);
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 12px;
    color: #D97706;
    line-height: 1.5;
}
</style>
